// @ts-ignore
import React from "react";

import { HomePageTemplate } from "../templates/home-page/src/index";

export const HomePage = () => <HomePageTemplate />;
